import { Component, ViewChild } from '@angular/core';
import { Observable, Subject } from 'rxjs';
//import { LoadingBarService } from '@ngx-loading-bar/core';
import { Router } from '@angular/router';
import { BranchInformationProperties } from '../models/BranchInformationProperties';
import { DxDataGridComponent } from 'devextreme-angular';
import { BranchService } from "../Services/branch.service";
declare var $;

@Component({
  selector: 'app-branch-list',
  templateUrl: './branch-list.component.html',
  styleUrls: ['./branch-list.component.css']
})
/** BranchList component*/
export class BranchListComponent {
  constructor(private branchService: BranchService, private router: Router) { }
  @ViewChild('#branchGrid', { static: false }) dataGrid: DxDataGridComponent;
  branchList: BranchInformationProperties[] = [];
  collapsed = false;


  contentReady = (e) => {
    $(".dx-datagrid-headers").css({ "background-color": "white", "color": "#212529", "font-weight": "bold" });
    if (!this.collapsed) {
      this.collapsed = true;
      e.component.expandRow(["EnviroCare"]);
    }
  };

  ngOnInit() {
    this.LoadBranchList();
  }
  LoadBranchList() {
    try {
      this.branchService.GetAllBranches().subscribe((data) => {
        this.branchList = data;
      });
    }
    catch (e) {

    }
  }

  AddNewBranch() {
    this.router.navigateByUrl('/branchInformation');
  }

  public Edit_Click(branchId) {
    localStorage.setItem('BranchListId', branchId);
    this.router.navigateByUrl('/branchInformation');
  }

  Manage_Click(agencyId) {
    try {

    }
    catch (e) {

    }
  }
}
